import { Chart as ChartJS } from 'chart.js';

const MAX_WAIT_MS = 5000;

function waitForChartsById(chartIds: string[], onReady: () => void) {
  const start = Date.now();

  const tick = () => {
    const allReady = chartIds.every((chartId) => ChartJS.getChart(chartId));
    const timedOut = Date.now() - start >= MAX_WAIT_MS;

    if (allReady || timedOut) {
      requestAnimationFrame(() => {
        onReady();
      });
      return;
    }

    requestAnimationFrame(tick);
  };

  requestAnimationFrame(tick);
}

export function replaceChartsWithImages(chartIds: string[], onComplete: () => void) {
  waitForChartsById(chartIds, () => {
    chartIds.forEach((chartID) => {
      const chart = ChartJS.getChart(chartID);
      if (chart) {
        const image = chart.toBase64Image('image/png', 1.0);
        const container = document.querySelector(`#${chartID}`);
        if (container && container.parentElement) {
          container.parentElement.innerHTML = `<img src="${image}" alt="Chart" style="width: 100%;" />`;
        }
      }
    });

    requestAnimationFrame(() => {
      onComplete();
    });
  });
}
